import React from 'react';
import {constant} from 'lodash/fp';

import {AcceleratorEligibleUntil} from '/component/partial/report/AcceleratorEligibleUntil';
import CabEligibleBonusIndicator from '/component/partial/report/CabEligibleBonusIndicator';
import ClientRole from '/component/partial/report/ClientRole';
import CoachesListHeader from '/component/partial/report/CoachesListHeader';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';

import {ReportProps} from '../Report.types';
import {generateOnRecordPress} from '../report.util';

import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

export const EligibleAcceleratorBonusContent = ({
  loadingData = {total: null},
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
  isViewTeam = false,
}: ReportProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
    isViewTeam,
  });

  if (!isReadyToLoad) {
    return null;
  }
  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: CoachesListHeader,
        personRoleComponent: ClientRole,
        personInfoComponent: AcceleratorEligibleUntil,
        PersonBonusIndicatorComponent: CabEligibleBonusIndicator,
        isCABReport: true,
        personIsCoach: constant(true),
        onRecordPress: generateOnRecordPress({
          showRecordPopover,
          recordsShowPopover,
          recordsShowRecord,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
